module.exports = __webpack_public_path__ + "img/none.72bb09aa.svg";